import { render, staticRenderFns } from "./ellipsisTips.vue?vue&type=template&id=10fcaaa9&scoped=true"
import script from "./ellipsisTips.vue?vue&type=script&lang=js"
export * from "./ellipsisTips.vue?vue&type=script&lang=js"
import style0 from "./ellipsisTips.vue?vue&type=style&index=0&id=10fcaaa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fcaaa9",
  null
  
)

export default component.exports